import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import ruLocale from './locales/ru'
import enLocale from './locales/en'
import locale from './config'
import Axios from 'axios'

import 'vuetify/dist/vuetify.min.css'
import { UI } from './assets/js/ui.js'

Vue.config.productionTip = false
Vue.config.silent = false
Vue.use(Vuetify)
Vue.use(VueI18n)
Vue.prototype.$http = Axios
Vue.prototype.$ui = new UI()

const TEST_MODE = false
Vue.prototype.$NEW_AUTH = true
Vue.prototype.$TEST_MODE = TEST_MODE
window.$TEST_MODE = TEST_MODE

function isSafari () {
  let isChrome = navigator.userAgent.indexOf('Chrome') > -1
  let isSafari = navigator.userAgent.indexOf('Safari') > -1
  if ((isChrome) && (isSafari)) isSafari = false
  if (TEST_MODE && isSafari) console.log('Browser detected as Safari')
  return isSafari
}

function getQueryParams (qs) {
  qs = qs.split('+').join(' ')

  let params = {}
  let tokens
  const re = /[?&]?([^=]+)=([^&]*)/g

  while (tokens = re.exec(qs)) { // eslint-disable-line
    if (tokens[1].indexOf('&') < 0) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
    } else {
      tokens[1] = tokens[1].split('&')
      params[decodeURIComponent(tokens[1][0])] = ''
      if (tokens[1].length > 1) params[decodeURIComponent(tokens[1][1])] = decodeURIComponent(tokens[2])
    }
  }

  return params
}

const base64json = require('base64json')

const decodeInstance = function (params) {
  if (typeof params !== 'object' || params == null) return null
  const instance = params.instance
  if (typeof instance === 'undefined' || instance.length === 0) return null
  const split = instance.split('.')
  if (split.length < 2) return null
  let decoded = base64json.parse(split[1])
  if (typeof decoded === 'object') return decoded
  let result = null

  try {
    result = JSON.parse(decoded)
  } catch (err) {
    if (TEST_MODE) {
      console.log(err)
      console.log(decoded)
    }
  }

  return result
}

const params = getQueryParams(window.location.search)
Vue.prototype.$wixInstanceId = (params.state !== undefined || window.location.pathname.indexOf('/statview') >= 0) ? params.state : Wix.Utils.getInstanceId() // eslint-disable-line
Vue.prototype.$instanceData = decodeInstance(params)
Vue.prototype.$isSafari = isSafari()
Vue.prototype.$siteInfo = {}

if (typeof Wix !== 'undefined') {
  Wix.Settings.getSiteInfo((siteInfo) => { // eslint-disable-line
    Vue.prototype.$siteInfo = siteInfo
    if (localStorage.getItem(`${Vue.prototype.$wixInstanceId}_metasiteId`) === null) {
      if (typeof siteInfo === 'object' && siteInfo !== null && siteInfo.url) {
        const params = getQueryParams(siteInfo.url)
        localStorage.setItem(`${Vue.prototype.$wixInstanceId}_metasiteId`, params.metaSiteId)
      }
    }
  })
} else {
  Vue.prototype.$wixMetaSiteId = ''
}

if (TEST_MODE) {
  Vue.prototype.$vcitaApiURL = 'https://app.meet2know.com/app'
  Vue.prototype.$dbapi = 'https://us-central1-hookshottest.cloudfunctions.net/dbapi'
  Vue.prototype.$vcitaAddress = 'meet2know.com'
  // Vue.prototype.$mixpanelToken = 'd482fd7678983cbb47786f77b1e63bbd'
  Vue.prototype.$mixpanelToken = '700b7818c6def5a4f09a8664c5860704'
} else {
  Vue.prototype.$vcitaApiURL = 'https://app.vcita.com/app'
  Vue.prototype.$dbapi = 'https://us-central1-hookshot-254511.cloudfunctions.net/dbapi'
  Vue.prototype.$vcitaAddress = 'vcita.com'
  Vue.prototype.$mixpanelToken = '78aa39b3aa49594f172cfccda537ef1a'
}

const messages = {
  ru: ruLocale,
  en: enLocale
}

const i18n = new VueI18n({
  locale: locale.getLocale(messages, Wix), // eslint-disable-line
  fallbackLocale: 'en',
  messages
})

new Vue({
  i18n,
  vuetify: new Vuetify(),
  router,
  render: h => h(App)
}).$mount('#app')

/*
if (module.hot) {
  module.hot.accept(['./locales/ru', './locales/en'], function () {
    i18n.setLocaleMessage('en', require('./locales/en').default)
    i18n.setLocaleMessage('ru', require('./locales/ru').default)
  })
}
*/
